import { IDataSourceConfig, ITransportConfig } from 'app/components/data/DataSource/interfaces'
import { LocalDataSource } from 'app/components/data/DataSource/Local'
import { HttpService } from 'app/components/data/DataSource/Remote/HttpService'
import { isObjAndNotNull, ObjectParser } from 'app/components/data/utils'

export abstract class RemoteDataSource<T extends object> extends LocalDataSource<T> {

  private initPromise: Promise<void> = Promise.resolve()
  private httpService: HttpService = new HttpService()

  constructor(config: IDataSourceConfig<T>) {
    super(config)

    const hasInitConfig = isObjAndNotNull(this.config.transport.init)

    if (hasInitConfig) {
      this.initPromise = this.httpService.fetchJSON<void>(this.config.transport.init)
    }
  }

  createRecord(record: T, urlParams?: object): Promise<T> {
    const updateConfig = this.config.transport.create
    const hasUpdateConfig = isObjAndNotNull(updateConfig)

    if (hasUpdateConfig) {
      updateConfig.request = updateConfig.request || {}
      updateConfig.request.body = JSON.stringify(record)
      updateConfig.request.headers = {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }

      return this.fetch<T>(updateConfig)
    } else {
      return Promise.reject('No Update Transport configured')
    }
  }

  removeRecord(record: T, urlParams?: object): Promise<boolean> {
    const removeConfig = this.config.transport.remove
    const hasRemoveConfig = isObjAndNotNull(removeConfig)

    if (hasRemoveConfig) {
      return this.fetch<null>(removeConfig, urlParams)
        .then(() => true)
        .catch(() => false)
    } else {
      return Promise.reject('No Remove Transport Configured')
    }
  }

  protected fetch<U>(transportConfig: ITransportConfig, urlParams?: object) {
    this.httpService.insertObjIntoVariables({
      $startIndex: this.startIndex,
      $endIndex: this.startIndex + this.size,
      $size: this.size,
      $sortBy: this.sortBy,
      $sortOrder: this.sortOrder,
      $searchWord: this.searchWord
    })

    return this.initPromise
      .then(() => this.httpService.fetchJSON<U>(transportConfig, urlParams))
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Remote/RemoteDataSource.ts